import React from "react";
import { UtensilsCrossed } from "lucide-react";
import { FilaPorcaoItem } from "../../../services/filaPorcoesService";
import { PorcaoColunaDef } from "../constants/porcoes";
import PorcaoItemCard from "./PorcaoItemCard";

interface PorcaoColunaProps {
  def: PorcaoColunaDef;
  items: FilaPorcaoItem[];
  actionId: number | null;
  onFinalizar: (id: number) => void;
}

const PorcaoColuna: React.FC<PorcaoColunaProps> = ({
  def,
  items,
  actionId,
  onFinalizar,
}) => {
  return (
    <div
      className={`flex w-[320px] shrink-0 flex-col rounded-xl border sm:w-[340px] ${def.accentClass}`}
    >
      <div className="flex items-center gap-2 border-b border-neutral-200/80 px-4 py-3">
        <UtensilsCrossed size={18} className="text-neutral-700" />
        <h2 className="text-sm font-bold text-neutral-800">{def.title}</h2>
        <span
          className={`ml-auto rounded-full px-2 py-0.5 text-xs font-semibold ${def.badgeClass}`}
        >
          {items.length}
        </span>
      </div>

      <div className="flex flex-col gap-3 overflow-y-auto p-3">
        {items.length === 0 ? (
          <p className="py-8 text-center text-sm text-neutral-400">
            Nenhum item
          </p>
        ) : (
          items.map((item) => (
            <PorcaoItemCard
              key={item.id}
              item={item}
              actionId={actionId}
              onFinalizar={onFinalizar}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default PorcaoColuna;
